// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/* ****Fonts**** */
/* ****Shadows (subtle elevation — flat SaaS)**** */
/* ****Border radius**** */
/* ****icon size**** */
/* **** Device width **** */
/* **** helper variable **** */
/* **** Motion **** */
.LoadingSpinner_spinner__wrapper__Tw98q {
  display: grid;
  place-items: center;
  min-height: 40vh;
}

.LoadingSpinner_spinner__40kOg {
  display: inline-block;
  width: 56px;
  height: 56px;
}

.LoadingSpinner_spinner__40kOg:after {
  content: " ";
  display: block;
  width: 48px;
  height: 48px;
  margin: 4px;
  border-radius: 50%;
  border: 3px solid var(--border-color);
  border-top-color: var(--primaryColor);
  animation: LoadingSpinner_spinner__40kOg 0.8s cubic-bezier(0.16, 1, 0.3, 1) infinite;
}

@keyframes LoadingSpinner_spinner__40kOg {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
@media (prefers-reduced-motion: reduce) {
  .LoadingSpinner_spinner__40kOg:after {
    animation: none;
    border-top-color: var(--primaryColor);
  }
}`, "",{"version":3,"sources":["webpack://./src/components/UI/loadingSpinner/LoadingSpinner.module.scss","webpack://./src/scss/abstracts/_variables.scss"],"names":[],"mappings":"AAAA,gBAAgB;ACAhB,kBAAA;AAeA,mDAAA;AAIA,0BAAA;AAKA,sBAAA;AAIA,2BAAA;AAMA,8BAAA;AAOA,qBAAA;ADvCA;EACE,aAAA;EACA,mBAAA;EACA,gBAAA;AAOF;;AAJA;EACE,qBAAA;EACA,WAAA;EACA,YAAA;AAOF;;AALA;EACE,YAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,qCAAA;EACA,qCAAA;EACA,oFAAA;AAQF;;AANA;EACE;IACE,uBAAA;EASF;EAPA;IACE,yBAAA;EASF;AACF;AANA;EACE;IACE,eAAA;IACA,qCAAA;EAQF;AACF","sourcesContent":["@use \"../../../scss/abstracts/\" as *;\r\n\r\n.spinner__wrapper {\r\n  display: grid;\r\n  place-items: center;\r\n  min-height: 40vh;\r\n}\r\n\r\n.spinner {\r\n  display: inline-block;\r\n  width: 56px;\r\n  height: 56px;\r\n}\r\n.spinner:after {\r\n  content: \" \";\r\n  display: block;\r\n  width: 48px;\r\n  height: 48px;\r\n  margin: 4px;\r\n  border-radius: 50%;\r\n  border: 3px solid var(--border-color);\r\n  border-top-color: var(--primaryColor);\r\n  animation: spinner 0.8s $ease-out infinite;\r\n}\r\n@keyframes spinner {\r\n  0% {\r\n    transform: rotate(0deg);\r\n  }\r\n  100% {\r\n    transform: rotate(360deg);\r\n  }\r\n}\r\n\r\n@media (prefers-reduced-motion: reduce) {\r\n  .spinner:after {\r\n    animation: none;\r\n    border-top-color: var(--primaryColor);\r\n  }\r\n}\r\n","/* ****Fonts**** */\r\n\r\n//Body size\r\n$fontSizeBodySmall: 12px;\r\n$fontSizeBodyMedium: 14px;\r\n$fontSizeBodyLarge: 16px;\r\n//Headline size\r\n$fontSizeHeadlineSmall: 24px;\r\n$fontSizeHeadlineMedium: 36px;\r\n$fontSizeHeadlineLarge: 48px;\r\n//Display size\r\n$fontSizeDisplaySmall: 56px;\r\n//helper font size\r\n$fontSizeTableStatus: 11px;\r\n\r\n/* ****Shadows (subtle elevation — flat SaaS)**** */\r\n$mainBoxShadow: 0 1px 2px rgba(15, 23, 42, 0.06), 0 8px 24px rgba(15, 23, 42, 0.06);\r\n$secondBoxShadow: 0 12px 40px rgba(15, 23, 42, 0.18);\r\n\r\n/* ****Border radius**** */\r\n$smallBorderRadius: 8px;\r\n$mediumBorderRadius: 12px;\r\n$largeBorderRadius: 16px;\r\n\r\n/* ****icon size**** */\r\n$smallIconSize: 20px;\r\n$largeIconSize: 48px;\r\n\r\n/* **** Device width **** */\r\n$mobile-width: 576px;\r\n$tablet-width: 768px;\r\n$desktop-width: 992px;\r\n$largeDesktop-width: 1200px;\r\n\r\n/* **** helper variable **** */\r\n$sideBarOpenWidth: 248px;\r\n$sideBarCloseWidth: 72px;\r\n$spacing: 60px;\r\n$mobileSpacing: 16px;\r\n$sideBarLogoHeight: 171px;\r\n\r\n/* **** Motion **** */\r\n$ease-out: cubic-bezier(0.16, 1, 0.3, 1);\r\n$duration-fast: 150ms;\r\n$duration-base: 200ms;\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"spinner__wrapper": `LoadingSpinner_spinner__wrapper__Tw98q`,
	"spinner": `LoadingSpinner_spinner__40kOg`
};
export default ___CSS_LOADER_EXPORT___;
